import '../../scss/title.scss'

export default function Title({ title }: { title: string }) {

    if (!title) {
        return null
    }

    return (
        <div className="title-ctn">
            <h2 className="bg-title">
                <span dangerouslySetInnerHTML={{ __html: title }} />
            </h2>
        </div>
    )
}